import React, { memo } from "react";
import useLoginPage from "./index.hooks";
import {
  AuthenticationContainer,
  GuestPageContainer,
  LoginForm,
} from "components";

type LoginPageProps = {};

const LoginPage = ({}: LoginPageProps) => {
  const { styles, atomicStyles } = useLoginPage();

  return (
    <GuestPageContainer>
      <AuthenticationContainer>
        <LoginForm />
      </AuthenticationContainer>
    </GuestPageContainer>
  );
};

export default memo(LoginPage);
